<template>
  <div class="aop-page">
    <div class="aop-container">
      <!-- 面包屑导航 -->
      <nav class="breadcrumb-nav">
        <router-link to="/">首页</router-link>
        <span class="separator">/</span>
        <router-link to="/product">产品中心</router-link>
        <span class="separator">/</span>
        <span class="current">审计作业系统</span>
      </nav>
    </div>

    <!-- 英雄区 -->
    <section class="aop-container" style="padding-top: 20px;">
      <div style="max-width: 1000px;">
        <h1>非现场数字化审计作业工具<br><span style="color: var(--aop-accent-blue);">远程审计 · 智能闭环 · 整改跟踪</span></h1>
        <p class="subhead">打造"大数据筛查 + 工单闭环 + 底稿自动生成 + 整改跟踪"的全流程远程审计平台，助力央企国企实现审计数字化转型。</p>
        <div style="display: flex; gap: 20px; flex-wrap: wrap;">
          <a href="#" class="btn btn-primary" @click.prevent="openModal">预约演示 <i class="fa-regular fa-calendar-check" style="margin-left: 8px;"></i></a>
          <a href="#" class="btn btn-outline" @click.prevent="downloadBrochure">下载产品手册 <i class="fa-regular fa-file-pdf" style="margin-left: 8px;"></i></a>
        </div>
      </div>

      <!-- 关键词云（SEO强化） -->
      <div class="keyword-cloud">
        <h2 class="keyword-tag highlight">非现场审计</h2>
        <h2 class="keyword-tag">远程审计</h2>
        <h2 class="keyword-tag">数字化审计</h2>
        <h2 class="keyword-tag">智能审计系统</h2>
        <h2 class="keyword-tag">审计工单管理</h2>
        <h2 class="keyword-tag">审计整改闭环</h2>
        <h2 class="keyword-tag">审计大数据平台</h2>
        <h2 class="keyword-tag">内部审计系统</h2>
        <h2 class="keyword-tag">审计底稿自动生成</h2>
        <h2 class="keyword-tag">风险预警审计</h2>
      </div>
    </section>

    <!-- 背景与挑战 -->
    <section class="aop-container">
      <h2><i class="fa-regular fa-triangle-exclamation"></i> 传统现场审计的痛点</h2>
      <div class="card-grid-3">
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-clock"></i></div>
          <h3>周期长 · 成本高</h3>
          <p>跨区域审计差旅成本高，项目周期动辄数月，数据获取效率低下。</p>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-chart-line"></i></div>
          <h3>覆盖面有限</h3>
          <p>受限于人力，只能抽查少量样本，难以发现系统性风险。</p>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-rotate-left"></i></div>
          <h3>整改难以闭环</h3>
          <p>发现问题后缺乏跟踪机制，整改情况不透明，问题易反复。</p>
        </div>
      </div>
      <p style="margin-top: 20px; font-size: 1.1rem;">同时，央企、国企对"内部审计数字化转型""风险管控智能化"提出更高监管要求，传统模式已无法满足。</p>
    </section>

    <!-- 解决方案核心功能 -->
    <section class="aop-container">
      <h2><i class="fa-regular fa-cubes"></i> 核心功能模块</h2>
      <div class="card-grid-4">
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-magnifying-glass-chart"></i></div>
          <h3>大数据疑点发现</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 审计模型自动筛查</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 风险预警与评估</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 持续监控型审计</li>
          </ul>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-ticket"></i></div>
          <h3>疑点工单一键生成</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 自动生成疑点清单</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 按项目组分发</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 多级审批与任务分派</li>
          </ul>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-arrows-spin"></i></div>
          <h3>核实追踪与反馈</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 在线核实任务</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 二次核实/核销退库</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 全流程留痕可追溯</li>
          </ul>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-file-lines"></i></div>
          <h3>审计底稿一键生成</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 标准化底稿自动生成</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 强关联疑点与附件</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 支持电子签章</li>
          </ul>
        </div>
      </div>
      <div style="text-align: center; margin-top: 20px;">
        <p><strong>+ 线上无纸化作业：</strong> 审计计划、任务下发、审核、归档全流程线上化，作业标准化、数据可追溯。</p>
      </div>
    </section>

    <!-- 应用场景 -->
    <section class="aop-container">
      <h2><i class="fa-regular fa-building"></i> 典型应用场景</h2>
      <div class="card-grid-3">
        <div class="feature-card">
          <h3>大数据疑点筛选</h3>
          <p>适用于集团公司、多级分支机构、跨区域审计、专项审计，大规模数据自动筛查，智能发现风险点。</p>
        </div>
        <div class="feature-card">
          <h3>线上工单管理</h3>
          <p>疑点生成、任务分发、在线核实、反馈处理，适用于内部审计、风险控制、合规管理部门。</p>
        </div>
        <div class="feature-card">
          <h3>审计底稿与整改管理</h3>
          <p>自动生成底稿、统一标准模板、附件归档；问题整改跟踪、责任追踪、闭环管理。</p>
        </div>
      </div>
    </section>

    <!-- 项目成果与价值（数据指标） -->
    <section class="aop-container">
      <h2><i class="fa-regular fa-chart-simple"></i> 项目成果与价值</h2>
      <div class="stat-grid">
        <div class="stat-card">
          <div class="stat-number">30%-60%</div>
          <p>审计效率提升</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">100%</div>
          <p>疑点闭环管理</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">50%+</div>
          <p>审计覆盖率提高</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">0</div>
          <p>线下纸质作业</p>
        </div>
      </div>
      <div style="margin-top: 40px;">
        <ul style="list-style: none;">
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 支撑央企国企数字化升级，满足监管要求，建立智能风控体系。</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 实现审计整改闭环管理：疑点 → 核实 → 底稿 → 整改 → 归档全流程可追溯。</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 推动审计数字化转型，构建智能化、平台化、闭环化的远程审计体系。</li>
        </ul>
      </div>
    </section>

    <!-- 适用客户类型 -->
    <section class="aop-container">
      <h2><i class="fa-regular fa-users"></i> 适用客户类型</h2>
      <div class="client-tags">
        <span class="client-tag">央企集团</span>
        <span class="client-tag">国有企业</span>
        <span class="client-tag">金融机构</span>
        <span class="client-tag">通信行业</span>
        <span class="client-tag">能源行业</span>
        <span class="client-tag">保险行业</span>
        <span class="client-tag">大型制造企业</span>
        <span class="client-tag">政府监管单位</span>
      </div>
    </section>

    <!-- 客户成功案例 -->
    <section class="aop-container">
      <h2><i class="fa-regular fa-briefcase"></i> 客户成功案例</h2>
      <div class="card-grid-3">
        <div class="case-card">
          <i class="fa-solid fa-building-columns" style="font-size: 2rem; color: var(--aop-primary-dark);"></i>
          <div class="case-stats">-45%</div>
          <p><strong>某大型能源集团</strong> — 上线远程审计平台后，跨区域审计周期从3个月缩短至1.5个月，问题整改率提升至98%。</p>
        </div>
        <div class="case-card">
          <i class="fa-solid fa-phone" style="font-size: 2rem; color: var(--aop-primary-dark);"></i>
          <div class="case-stats">+60%</div>
          <p><strong>省级通信运营商</strong> — 通过大数据疑点筛查，发现风险点数量增加60%，并实现工单自动分发与闭环跟踪。</p>
        </div>
        <div class="case-card">
          <i class="fa-solid fa-truck" style="font-size: 2rem; color: var(--aop-primary-dark);"></i>
          <div class="case-stats">100%</div>
          <p><strong>大型制造企业</strong> — 无纸化审计覆盖所有分子公司，底稿编制时间减少70%，整改完成率达到100%。</p>
        </div>
      </div>
    </section>

    <!-- 常见问题 FAQ -->
    <section class="aop-container">
      <h2 style="text-align: center;"><i class="fa-regular fa-circle-question"></i> 常见问题</h2>
      <div class="faq-list">
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 该系统是否支持与现有ERP/财务系统对接？</div>
          <div class="faq-answer">支持。古杉数据审计平台提供标准化API接口，可快速对接SAP、Oracle、用友、金蝶等主流ERP系统，以及数据中台和数据湖。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 如何保证数据安全与合规性？</div>
          <div class="faq-answer">系统支持私有化部署，符合等保2.0、国资监管要求。所有操作留痕，数据加密传输与存储，可满足央企内部审计合规要求。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 是否支持移动端审批与核实？</div>
          <div class="faq-answer">是的，提供配套移动端（钉钉/企微/独立APP），支持任务提醒、在线核实、附件上传、审批等，实现随时随地办公。</div>
        </div>
      </div>
    </section>

    <!-- 最终CTA -->
    <section class="aop-container" style="padding-bottom: 80px;">
      <div class="cta-block">
        <h2 style="font-size: 2.4rem;">开启审计数字化转型</h2>
        <p style="font-size: 1.2rem; margin: 16px 0 40px; opacity: 0.9;">预约专家演示，了解如何将审计效率提升60%，实现整改闭环。</p>
        <div style="display: flex; gap: 20px; justify-content: center; flex-wrap: wrap;">
          <a href="#" class="btn btn-primary" @click.prevent="openModal" style="background: white; color: var(--aop-primary-dark);">预约免费演示</a>
          <a href="tel:400-xxx-xxxx" class="btn btn-outline" style="border-color: white; color: white;">致电 400-xxx-xxxx</a>
        </div>
        <p style="margin-top: 32px; font-size: 1rem;"><i class="fa-regular fa-envelope"></i> 发送需求至 audit@gushandata.cn</p>
      </div>
    </section>

    <!-- 预约演示模态框 -->
    <div class="modal" :style="{ display: showModal ? 'flex' : 'none' }">
      <div class="modal-content">
        <span class="close-modal" @click="closeModal">&times;</span>
        <h3><i class="fa-regular fa-calendar-check" style="color: var(--aop-primary-dark);"></i> 预约专家演示</h3>
        <form @submit.prevent="submitDemo">
          <div class="form-group">
            <input type="text" v-model="form.name" placeholder="姓名 *" required>
          </div>
          <div class="form-group">
            <input type="text" v-model="form.company" placeholder="公司名称">
          </div>
          <div class="form-group">
            <input type="email" v-model="form.email" placeholder="工作邮箱 *" required>
          </div>
          <div class="form-group">
            <input type="tel" v-model="form.phone" placeholder="联系电话">
          </div>
          <div class="form-group">
            <textarea rows="3" v-model="form.message" placeholder="您的需求或问题（选填）"></textarea>
          </div>
          <button type="submit" class="btn btn-primary">提交预约</button>
        </form>
      </div>
    </div>

    <!-- footer -->
    <footer class="aop-container">
      <p>© 2026 古杉数据 · 非现场数字化审计作业工具 | 远程审计 · 智能闭环</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'AuditOperationDetail',
  data() {
    return {
      showModal: false,
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    submitDemo() {
      alert('感谢您的预约，古杉数据专家将在24小时内与您联系。');
      this.showModal = false;
      this.form = { name: '', company: '', email: '', phone: '', message: '' };
    },
    downloadBrochure() {
      alert('产品手册下载中…… (实际可替换为PDF链接)');
    }
  }
};
</script>

<style scoped>
.aop-page {
  --aop-primary-dark: #1D4E4E;
  --aop-primary-soft: #e9f3f2;
  --aop-accent-gold: #D4AF37;
  --aop-accent-blue: #2A7DE1;
  --aop-gray-light: #f8fafc;
  --aop-gray-border: #e2e8f0;
  --aop-text-dark: #0f2a2a;
  --aop-text-regular: #2d3f4b;
  --aop-white: #ffffff;
  --aop-shadow: 0 12px 30px rgba(0, 40, 40, 0.06);

  background-color: #ffffff;
  color: var(--aop-text-regular);
  line-height: 1.5;
  font-family: 'Inter', 'PingFang SC', 'Roboto', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 面包屑导航 */
.breadcrumb-nav {
  padding: 20px 0;
  font-size: 0.9rem;
  border-bottom: 1px solid var(--aop-gray-border);
  margin-bottom: 20px;
}

.breadcrumb-nav a {
  color: var(--aop-primary-dark);
  text-decoration: none;
  font-weight: 500;
}

.breadcrumb-nav a:hover {
  text-decoration: underline;
}

.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #999;
}

.breadcrumb-nav .current {
  color: var(--aop-accent-blue);
  font-weight: 600;
}

.aop-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}

section.aop-container {
  padding: 64px 24px;
}

h1, h2, h3 {
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--aop-text-dark);
}

h1 {
  font-size: 3.2rem;
  line-height: 1.2;
}

h2 {
  font-size: 2.2rem;
  margin-bottom: 24px;
}

h2 i {
  color: var(--aop-accent-blue);
  margin-right: 8px;
}

h3 {
  font-size: 1.4rem;
  margin-bottom: 12px;
}

.subhead {
  font-size: 1.2rem;
  color: #4f6f7f;
  max-width: 800px;
  margin-bottom: 40px;
}

.btn {
  display: inline-block;
  padding: 12px 30px;
  border-radius: 40px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 1rem;
  border: 1px solid transparent;
  cursor: pointer;
}

.btn-primary {
  background-color: var(--aop-primary-dark);
  color: white;
  box-shadow: 0 4px 12px rgba(29, 78, 78, 0.25);
}

.btn-primary:hover {
  background-color: #0e3a3a;
  transform: translateY(-2px);
}

.btn-outline {
  background-color: transparent;
  border: 1.5px solid var(--aop-primary-dark);
  color: var(--aop-primary-dark);
}

.btn-outline:hover {
  background-color: var(--aop-primary-dark);
  color: white;
}

.btn-accent {
  background-color: var(--aop-accent-blue);
  color: white;
  box-shadow: 0 4px 12px rgba(42, 125, 225, 0.3);
}

.btn-accent:hover {
  background-color: #1b64c5;
  transform: translateY(-2px);
}

/* 关键词标签云 */
.keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.keyword-tag {
  background: var(--aop-primary-soft);
  color: var(--aop-primary-dark);
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.keyword-tag.highlight {
  background: var(--aop-accent-gold);
  color: #1e3c3c;
}

/* 卡片网格 */
.card-grid-3, .card-grid-4 {
  display: grid;
  gap: 24px;
  margin: 40px 0;
}

.card-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.card-grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

.feature-card {
  background: white;
  border-radius: 24px;
  padding: 28px 24px;
  box-shadow: var(--aop-shadow);
  border: 1px solid var(--aop-gray-border);
  transition: transform 0.2s;
}

.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(29, 78, 78, 0.1);
}

.card-icon {
  font-size: 2.5rem;
  color: var(--aop-primary-dark);
  margin-bottom: 20px;
}

.list-item {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  align-items: flex-start;
}

.list-item i {
  color: var(--aop-accent-blue);
  font-size: 1.1rem;
  margin-top: 3px;
  min-width: 20px;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 40px;
}

.stat-card {
  background: var(--aop-primary-soft);
  border-radius: 32px;
  padding: 32px 24px;
  text-align: center;
}

.stat-number {
  font-size: 2.8rem;
  font-weight: 700;
  color: var(--aop-primary-dark);
  margin-bottom: 8px;
}

.client-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.client-tag {
  background: white;
  border: 1px solid var(--aop-gray-border);
  padding: 8px 22px;
  border-radius: 40px;
  font-weight: 500;
  color: var(--aop-text-dark);
}

.case-card {
  background: white;
  border-radius: 24px;
  padding: 28px;
  box-shadow: var(--aop-shadow);
}

.case-stats {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--aop-primary-dark);
  margin: 16px 0 8px;
}

/* FAQ */
.faq-list {
  max-width: 900px;
  margin: 40px auto 0;
}

.faq-item {
  padding: 22px 0;
  border-bottom: 1px solid var(--aop-gray-border);
}

.faq-question {
  font-weight: 700;
  font-size: 1.2rem;
  display: flex;
  gap: 16px;
  color: var(--aop-text-dark);
}

.faq-question i {
  color: var(--aop-accent-gold);
}

.faq-answer {
  margin-top: 12px;
  color: #3f5465;
  padding-left: 40px;
}

.cta-block {
  background: var(--aop-primary-dark);
  border-radius: 56px;
  padding: 64px 56px;
  color: white;
  text-align: center;
}

.cta-block h2 {
  color: white;
}

.cta-block .btn-primary {
  background-color: white;
  color: var(--aop-primary-dark);
  margin: 0 8px;
}

.cta-block .btn-outline {
  border-color: white;
  color: white;
}

.cta-block .btn-outline:hover {
  background-color: white;
  color: var(--aop-primary-dark);
}

/* 模态框 */
.modal {
  display: none;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  border-radius: 40px;
  max-width: 500px;
  width: 90%;
  padding: 40px;
  box-shadow: 0 30px 60px rgba(0,0,0,0.3);
  position: relative;
}

.close-modal {
  position: absolute;
  top: 20px;
  right: 24px;
  font-size: 28px;
  cursor: pointer;
  color: #999;
}

.modal h3 {
  margin-bottom: 24px;
}

.modal .form-group {
  margin-bottom: 20px;
}

.modal input, .modal textarea {
  width: 100%;
  padding: 12px 18px;
  border: 1px solid var(--aop-gray-border);
  border-radius: 30px;
  font-size: 1rem;
  outline: none;
}

.modal textarea {
  border-radius: 20px;
}

.modal .btn {
  width: 100%;
  margin-top: 10px;
}

footer {
  text-align: center;
  padding: 40px 0;
  color: #7f8d9c;
  border-top: 1px solid var(--aop-gray-border);
  margin-top: 40px;
}

/* 响应式 */
@media (max-width: 1000px) {
  .card-grid-3, .card-grid-4, .stat-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .card-grid-3, .card-grid-4, .stat-grid {
    grid-template-columns: 1fr;
  }
  .aop-page h1 { font-size: 2.5rem; }
}
</style>
